import firebase from 'firebase/app';
import "firebase/auth";
import "firebase/storage";
import "firebase/database";
import "firebase/functions";

const config = {
    apiKey: "AIzaSyC5wefQnFfRju4csnUXOMl9lYx0TGs46XE",
    authDomain: "ranagard-9e27f.firebaseapp.com",
    projectId: "ranagard-9e27f",
    storageBucket: "ranagard-9e27f.appspot.com",
    messagingSenderId: "1066282517941",
    appId: "1:1066282517941:web:0ad500cfb866d3d6f505fc",
    measurementId: "G-BCXRRPQSRL"
};

var fireClone = firebase.initializeApp(config,"clone");
export default fireClone;
